// This is the small upload component used in the stages of data import
// this component is imported and used in every tab of data import where there is an
// upload option. The main functionality is based on an input element that receives files
// in only CSV format.

// this component receives the following props (properties as functions or data):
// Id:the id consdered for each component (never identical)
// Placeholder: a string for empty state before initializing the upload
// UploadStarted: a function that is in the parent component for handling actions after the upload has started
// UploadEnded: same as UploadStarted for actions after the upload has ended
// AnotherUploadInProgress: to have the state of another upload being in progress (boolean)
// FileDeleted: a function to handle actions on parent after deleting an uploaded file
// TrigUpload: calls the API for uploading the actual file to the server
// Enum: a string value based on the BE approach for fetching history logs for each uploader
// link to BackEnd documentation:
// https://dev-apigateway.connexing.io/data-import-service/swagger-ui/index.html
// API_Name: a part of the URL in requests based on the tab the widget is imported in
// SwitchErrorState: a function that sets the state of the error status (boolean) to the opposite
// RemoveErrorState: a function that sets the error state on the parent to undefined to prevent displaying previous state

import axios from "axios";
import React, { useState, useEffect } from "react";
import "../../../../../../Assets/Styles/UploadWidget.scss";
import { Config } from "../../../../../../Config";
import SummaryModal from "./SummaryModal";
import Rotator from "../../../../../../Assets/Images/ButtonLoadingIcon.svg";

const UploadWidget = (props) => {
  const [FileIsUploaded, setFileIsUploaded] = useState(false);
  const [IsUploading, setIsUploading] = useState(false);
  const [SummaryIsOpen, setSummaryIsOpen] = useState(false);
  const [SummaryData, setSummaryData] = useState({});
  const [PrevFileUploaded, setPrevFileUploaded] = useState(false);
  const [IsEmptyFile, setIsEmptyFile] = useState(false);
  const [FileTypeIsWrong, setFileTypeIsWrong] = useState(false);

  useEffect(() => {
    fetchFileUploadSummary();
  }, []);

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  // clicks the trigger button of the input with type of file
  const handleUpload = () => {
    document.getElementById(props.Id + "-file").click();
  };

  const handleInputChange = () => {
    setIsUploading(true);
    props.RemoveErrorState();
    props.UploadStarted();
    props.UpdatePrevFileCount();
    setTimeout(() => {
      startUploadProgressBar();
    }, 1500);
  };
  const deleteFile = () => {
    let Req = {
      method: "DELETE",
      baseURL:
        window._env_.API_URL +
        Config.DataImportURL +
        "/api/" +
        props.API_Name +
        "/delete-log-and-file/",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        document.getElementById(props.Id + "-file").value = null;
        setFileIsUploaded(false);
        setIsUploading(false);
        props.FileDeleted();
        props.UpdateMandatoriesStatus();
      })
      .catch((Err) => {
        console.log(Err);
        if (Err.response.status === 404) {
          document.getElementById(props.Id + "-file").value = null;
          setFileIsUploaded(false);
          setIsUploading(false);
          props.FileDeleted();
        }
      });
  };
  const startUploadProgressBar = () => {
    if (document.getElementById(props.Id + "-progress-bar") !== null) {
      document.getElementById(props.Id + "-progress-bar").style.width = "10%";
    }
    setTimeout(() => {
      if (document.getElementById(props.Id + "-progress-bar") !== null) {
        document.getElementById(props.Id + "-progress-bar").style.width = "90%";
      }
    }, 500);
    setTimeout(() => {
      if (document.getElementById(props.Id + "-progress-bar") !== null) {
        document.getElementById(props.Id + "-progress-bar").style.width = "98%";
        setIsUploading(false);
        setFileIsUploaded(true);
        props.TrigUpload();
        props.UploadEnded();
      }
    }, 1000);
  };
  const cancelUpload = () => {
    setFileIsUploaded(false);
    setIsUploading(false);
    document.getElementById(props.Id + "-file").value = "";
    props.UploadEnded();
  };
  const shortenFileName = (Name) => {
    if (Name.length < 38) {
      return Name;
    } else {
      return Name.slice(0, 34) + " ...";
    }
  };

  const openSummaryModal = () => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.DataImportURL +
        "/api/" +
        props.API_Name +
        "/view-log",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        if (Res.data.fileSize <= 1) {
          setIsEmptyFile(true);
        } else {
          setIsEmptyFile(false);
        }
        let FileExtention = Res.data.fileName.slice(
          Res.data.fileName.indexOf("."),
          Res.data.fileName.length
        );
        if (FileExtention !== ".csv") {
          setFileTypeIsWrong(true);
        } else {
          setFileTypeIsWrong(false);
        }
        setSummaryData(Res.data);
        setSummaryIsOpen(true);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };
  // checks if there are any previously uploaded version of the file for this input widget
  const fetchFileUploadSummary = () => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.DataImportURL +
        "/api/" +
        props.API_Name +
        "/view-log",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
        Accept: "*/*",
        Connection: "keep-alive",
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setSummaryData(Res.data);
        setPrevFileUploaded(true);
        setFileIsUploaded(true);
        if (Res.data.status !== "SUCCESS") {
          props.SwitchErrorState();
          checkFileExtension(Res.data.fileName);
        }
      })
      .catch((Err) => {
        console.log(Err.response);
        setPrevFileUploaded(false);
      });
  };

  const checkFileExtension = (FileName) => {
    let FileExtention = FileName.slice(FileName.indexOf("."), FileName.length);

    if (document.getElementById(props.Id + "-error") !== null) {
      if (FileExtention !== ".csv") {
        document.getElementById(props.Id + "-error").innerHTML = translateText(
          "data_import_widget_error_csv_file"
        );
      }
    }
    return FileName;
  };

  return (
    <React.Fragment>
      <input
        accept=".csv"
        className="hidden"
        type="file"
        id={props.Id + "-file"}
        onChange={() => handleInputChange()}
      />
      <div className="upload-widget">
        {SummaryIsOpen ? (
          <SummaryModal
            Data={SummaryData}
            close={() => setSummaryIsOpen(false)}
            IsEmptyFile={IsEmptyFile}
            FileName={props.Placeholder}
            FileTypeIsWrong={FileTypeIsWrong}
            LangData={props.LangData}
          />
        ) : null}
        {IsUploading ? (
          <div className="uploading-state">
            <p className="csv-name uploaded">
              {shortenFileName(
                checkFileExtension(
                  document.getElementById(props.Id + "-file").files[0].name
                )
              )}
            </p>
            <section className="upload-progress-holder">
              <span id={props.Id + "-progress-bar"}></span>
            </section>
          </div>
        ) : (
          <React.Fragment>
            {FileIsUploaded ? (
              <p className="csv-name uploaded">
                {document.getElementById(props.Id + "-file").files[0] ===
                undefined
                  ? shortenFileName(checkFileExtension(SummaryData.fileName))
                  : shortenFileName(
                      checkFileExtension(
                        document.getElementById(props.Id + "-file").files[0]
                          .name
                      )
                    )}
              </p>
            ) : (
              <p className="csv-name">{props.Placeholder}</p>
            )}
          </React.Fragment>
        )}
        {IsUploading ? (
          <button onClick={() => cancelUpload()} className="upload cancel">
            {translateText("cancel")}
          </button>
        ) : (
          <React.Fragment>
            {FileIsUploaded ? (
              <React.Fragment>
                {props.UploadHadErrors === undefined ? (
                  <img alt="" src={Rotator} className="upload-rotator" />
                ) : (
                  <React.Fragment>
                    {props.UploadHadErrors ? (
                      <i id={props.Id + "-check"} className="feather-x"></i>
                    ) : (
                      <i id={props.Id + "-check"} className="feather-check"></i>
                    )}
                  </React.Fragment>
                )}
              </React.Fragment>
            ) : (
              <React.Fragment>
                {props.AnotherUploadInProgress ? (
                  <button
                    onClick={() => null}
                    id={props.Id + "-btn"}
                    className="upload upload-disabled"
                  >
                    {translateText("upload")}
                  </button>
                ) : (
                  <button
                    onClick={() => handleUpload()}
                    id={props.Id + "-btn"}
                    className="upload"
                  >
                    {translateText("upload")}
                  </button>
                )}
              </React.Fragment>
            )}
          </React.Fragment>
        )}
        {FileIsUploaded ? (
          <section className="after-upload-options">
            <i
              onClick={() => openSummaryModal()}
              className="feather-alert-circle"
            >
              <p>{translateText("data_import_summary")}</p>
            </i>
            <i onClick={() => deleteFile()} className="feather-trash-2">
              <p>{translateText("delete_the_file")}</p>
            </i>
          </section>
        ) : null}
      </div>
      {props.UploadHadErrors && FileIsUploaded ? (
        <p id={props.Id + "-error"} className="upload-widget-error">
          {SummaryData.fileSize <= 1
            ? translateText("data_import_widget_error_non_empty")
            : translateText("data_import_fix_and_upload_again_error") + "."}
        </p>
      ) : null}
    </React.Fragment>
  );
};
export default UploadWidget;
